import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ApiService } from '../../api.service';
import { ToastrService } from 'ngx-toastr';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
	selector: 'app-view-pdf',
	templateUrl: './view-pdf.component.html',
	styleUrl: './view-pdf.component.css'
})
export class ViewPdfComponent implements OnInit {
	breadcrumbList: any[] = [
		{
			path: this.apiService.getHomeURL(),
			name: "Home"
		},
		{
			path: "/app/list-appointment",
			name: "Appointment List"
		}
	];
	uId: any = null;
	billId: any = null;
	type: any = null;
	pageLoading = false;
	pagetitle: string = "Invoice";
	fileURL: any = null;

	constructor(private sanitizer: DomSanitizer, private apiService: ApiService, private activeRoute: ActivatedRoute, private toastr: ToastrService) { }
	ngOnInit(): void {
		this.activeRoute.params.subscribe(routeParams => {
			this.uId = routeParams["uId"];
			this.billId = routeParams["id"];
			this.type = routeParams["type"];
			this.breadcrumbList.push({ path: "/app/appt-details/no/" + this.uId + "/empty", name: "Appointment Details" });
			this.breadcrumbList.push({ path: "/app/case-invoice/" + this.uId, name: "Invoices" });
			this.breadcrumbList.push({ path: "/app/invoice-pdf/" + this.type + "/" + this.uId + "/" + this.billId, name: "Invoice PDF" });
			if (this.type == 'inr') {
				this.getINRInvoicePDF();
				this.pagetitle = "INR Invoice";
			} else {
				this.getUSDInvoicePDF();
				this.pagetitle = "USD Invoice";
			}
		});
	}

	getINRInvoicePDF() {
		this.pageLoading = true;
		this.apiService.invoicePDFINR({ id: this.billId }).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				var file = new Blob([data.body], { type: 'application/pdf' });
				this.fileURL = this.getSafeUrl(URL.createObjectURL(file));
			}, error: (error) => {
				this.pageLoading = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getUSDInvoicePDF() {
		this.pageLoading = true;
		this.apiService.invoicePDFUSD({ id: this.billId }).subscribe({
			next: (data: any) => {
				this.pageLoading = false;
				var file = new Blob([data.body], { type: 'application/pdf' });
				this.fileURL = this.getSafeUrl(URL.createObjectURL(file));
			}, error: (error) => {
				this.pageLoading = false;
				this.toastr.error('Something went wrong', 'Error', {
					timeOut: 3000,
					tapToDismiss: true,
					closeButton: true
				});
			}
		});
	}

	getSafeUrl(url: any) {
		return this.sanitizer.bypassSecurityTrustResourceUrl(url)
	}
}
